import React, { Component } from "react";
import { Col, Row, Button, Input, Card, CardBody, FormGroup } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  // DeliveryOrderItem
  getDeliveryOrderItems,
  addNewDeliveryOrderItems,
  deleteDeliveryOrderItems,
  clearDeliveryOrderItemError,
} from "store/actions";
import ConfirmDeleteModal from "components/Common/ConfirmDeleteModal";
import SelectionListModal from "containers/order/SelectionListModal";
import VerifyOrderTrackingModalForm from "containers/order/VerifyOrderTrackingModalForm";
import DeliveryOrderItemTable from "containers/delivery-order/DeliveryOrderItemTable";

export class DeliveryOrderItemTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderId: null,
      deliveryOrderId: null,
      selectedIds: [],
      currentPage: 1,
      pageSize: 10,
      deliveryOrderStatus: 0,

      modalAddOrder: false,
      modalConfirmDeleteIsOpen: false,
      modalVerifyOrderIsOpen: false,
    };
  }

  toggleModalConfirmDelete = () => {
    this.setState(prevState => ({
      modalConfirmDeleteIsOpen: !prevState.modalConfirmDeleteIsOpen,
    }));
  };

  toggleVerifyOrderModal = () => {
    this.setState(prevState => ({
      modalVerifyOrderIsOpen: !prevState.modalVerifyOrderIsOpen,
    }));
  };

  componentDidMount = () => {
    const { deliveryOrderId, deliveryOrderStatus } = this.props;

    this.setState({
      deliveryOrderId,
      deliveryOrderStatus,
    });
  };

  static getDerivedStateFromProps(props, state) {
    const { deliveryOrderId, deliveryOrderStatus } = props;
    if (deliveryOrderId !== state.deliveryOrderId) {
      getDeliveryOrderItems({ deliveryOrderId });
      return {
        deliveryOrderId,
        deliveryOrderStatus,
      };
    }

    return null;
  }

  componentDidUpdate() {
    const { error } = this.props;
    if (error) {
      toastr.options = {
        timeOut: 5000,
      };
      toastr.error(error, "Error");
      this.props.clearDeliveryOrderItemError();
    }
  }

  toggleAddOrder = () => {
    this.setState(prevState => ({
      modalAddOrder: !prevState.modalAddOrder,
    }));
  };

  handleOnAddNew = () => {
    this.setState({
      modalAddOrder: true,
    });
  };

  handleOnSubmit = ids => {
    const { addNewDeliveryOrderItems } = this.props;
    const { deliveryOrderId } = this.state;

    if (deliveryOrderId) {
      addNewDeliveryOrderItems({ deliveryOrderId, orderIds: ids });
      this.setState({
        modalAddOrder: false,
      });
    }
  };

  handleOnRemove = ids => {
    this.setState({
      selectedIds: ids,
      modalConfirmDeleteIsOpen: true,
    });
  };

  handleDelete = () => {
    const { deliveryOrderId, selectedIds } = this.state;
    const { deleteDeliveryOrderItems } = this.props;
    deleteDeliveryOrderItems({ deliveryOrderId, orderIds: selectedIds });
    this.setState({
      modalConfirmDeleteIsOpen: false,
    });
  };

  handleOnPageChange = page => {
    const { deliveryOrderId, pageSize } = this.state;
    this.props.getDeliveryOrderItems({
      deliveryOrderId,
      page,
      pageSize,
    });
    this.setState({
      currentPage: page,
    });
  };

  handleOnPageSizeChange = pageSize => {
    const { deliveryOrderId } = this.state;
    this.props.getDeliveryOrderItems({
      deliveryOrderId,
      page: 1,
      pageSize,
    });

    this.setState({
      pageSize,
    });
  };

  handleOnVerifyOrder = id => {
    this.setState({
      orderId: id,
      modalVerifyOrderIsOpen: true,
    });
  };

  render() {
    const {
      deliveryOrder,
      deliveryOrderItem,
      isReceiver,
      deliveryOrderStatus,
    } = this.props;
    const { items, itemCount, pageCount, loading } = deliveryOrderItem;
    const { pageSize, currentPage } = this.state;

    return (
      <Row>
        <Col md={12}>
          <DeliveryOrderItemTable
            items={items}
            itemCount={itemCount}
            currentPage={currentPage}
            defaultPageSize={pageSize}
            totalPage={pageCount}
            transportStatus={deliveryOrder?.item?.status}
            loading={loading}
            onAddNew={this.handleOnAddNew}
            onVerifyOrder={this.handleOnVerifyOrder}
            onRemove={this.handleOnRemove}
            onChangePage={this.handleOnPageChange}
            onPageSizeChange={this.handleOnPageSizeChange}
            isReceiver={isReceiver}
            deliveryOrderStatus={deliveryOrderStatus}
          />
        </Col>

        <SelectionListModal
          title={"Order Selection"}
          toggle={this.toggleAddOrder}
          isOpen={this.state.modalAddOrder}
          onSubmit={this.handleOnSubmit}
          orderParams={{ deliveryStatus: [3] }} // In Cambodia Warehouse
        />

        <ConfirmDeleteModal
          title="Confirm Delete"
          isOpen={this.state.modalConfirmDeleteIsOpen}
          toggle={this.toggleModalConfirmDelete}
          onSubmit={this.handleDelete}
        />

        <VerifyOrderTrackingModalForm
          title="Verify Order Tracking Number"
          orderId={this.state.orderId}
          isOpen={this.state.modalVerifyOrderIsOpen}
          toggle={this.toggleVerifyOrderModal}
        />
      </Row>
    );
  }
}

DeliveryOrderItemTab.propTypes = {
  isReceiver: PropTypes.bool,
  deliveryOrder: PropTypes.object,
  deliveryOrderItem: PropTypes.object,
  deliveryOrderId: PropTypes.string,
  itemCount: PropTypes.number,
  pageCount: PropTypes.number,
  getTransports: PropTypes.func,
  addNewDeliveryOrderItems: PropTypes.func,
  getDeliveryOrderItems: PropTypes.func,
  deliveryOrderStatus: PropTypes.number,

  error: PropTypes.string,
  clearDeliveryOrderItemError: PropTypes.func,
  deleteDeliveryOrderItems: PropTypes.func,

  history: PropTypes.object,
};

const mapStateToProps = ({ deliveryOrder, deliveryOrderItem }) => {
  return {
    deliveryOrder,
    deliveryOrderItem,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getDeliveryOrderItems,
    addNewDeliveryOrderItems,
    clearDeliveryOrderItemError,
    deleteDeliveryOrderItems,
  })(DeliveryOrderItemTab)
);
